var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfidentiality(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#45355C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.213 16.446h-.47v-2.86a3.77 3.77 0 00-3.767-3.766 3.771 3.771 0 00-3.766 3.767v2.859h-.471c-.81 0-1.467.656-1.467 1.467v6.804c0 .81.657 1.466 1.467 1.466h8.474c.81 0 1.467-.656 1.467-1.466v-6.804c0-.81-.657-1.467-1.467-1.467zm-6.684-2.86a2.452 2.452 0 012.449-2.45 2.451 2.451 0 012.448 2.45v2.859H15.53v-2.86zm3.198 9.486v-1.831a1.332 1.332 0 10-1.5 0v1.831a.75.75 0 101.5 0z",
    fill: "#fff"
  })));
}
export default SvgConfidentiality;